import invitedToAgreed from "./invitedToAgreed";
import revTypeByTimePeriod from "./report-type-by-time-period";

export default [...invitedToAgreed, ...revTypeByTimePeriod];
